import { track as amplitudeTrack } from '../lib/analytics';
import { track as intercomTrack, startChecklist, startTour } from '../lib/intercom';

export const useAnalytics = () => {
	return {
		track: amplitudeTrack, // retro compatible with current analytics
		trackEvent, // multi platform event tracking

		startChecklist,
		startTour,
	};
};

function trackEvent(event: string, data?: any) {
	// track to amplitude
	amplitudeTrack(event, data);
	// track to Intercom
	intercomTrack(event, data);
}
